<h2 style="margin: 0 0 10px;">Die Regelungen</h2>
<div>Letzte Aktualisierung Reisekompass {{today | date}}</div>
<span style="margin-top: .5rem;">
    Diese oben gezeigte unverbindliche Zusammenstellung unterliegt kurzfristigen
    Änderungen, somit
    sind alle Angaben ohne Gewähr und Anspruch auf Vollständigkeit. Wir empfehlen daher,
    dass Sie
    sich unbedingt auch immer bei den für Sie zuständigen Behörden zu informieren.
    Personen gelten erst dann als geimpft, wenn seit der Zweit-Impfung mindestens 14
    Tage vergangen
    sind.</span>